<template>
    <div class="favourites-page flex w-full">
        <div
            class="nav-sidebar"
            id="favourites-page-sidebar"
            v-sticky="stickyConfig"
        >
            <SidebarContainer />
        </div>
        <div class="main">
            <div class="overflow__padding stick-below-navbar">
                <div class="section-header">
                    <div class="section-header__left">
                        <span class="icon section-header__icon icon-competition"></span>
                        <span class="section-header__title">{{ $t('favourite tournaments') | capitalize }}</span>
                    </div>
                </div>
            </div>
            <OfferContainer
                :isFetcher="true"
                :shouldFetchAll="true"
            >
                <FavouritesOfferContainer />
            </OfferContainer>
        </div>
        <div class="right-sidebar">
            <BetSlipContainer />
        </div>
    </div>
</template>

<script>
    import SidebarContainer from '@modules/sportOffer/sidebar/SidebarContainer.vue';
    import FavouritesOfferContainer from '@modules/sportOffer/favourites/content/FavouritesOfferContainer.vue';
    import BetSlipContainer from '@modules/sportOffer/betSlip/BetSlipContainer.vue';
    import OfferContainer from '@modules/sportOffer/OfferContainer.vue';

    export default {
        name: 'FavouritesPage',
        created() {
            this.stickyConfig = {
                scrollableContentSelector: '.sidebar__responsive__element',
                staticHigherContentSelector: '.sidebar_static__top, .nav-sidebar__wrapper:not(:last-child)',
            };
        },
        components: {
            OfferContainer,
            BetSlipContainer,
            FavouritesOfferContainer,
            SidebarContainer,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/pages/FavouritesPage.vue